/**
 * In-flight GET dedupe + short TTL cache for idempotent workout reads.
 * Mutations call invalidateWorkoutCachePrefix.
 */

const DEFAULT_TTL_MS = 30_000;

const inflight = new Map();
const cache = new Map();

function cacheKey(method, url, params) {
  const paramStr = params ? JSON.stringify(params) : '';
  return `${method}:${url}:${paramStr}`;
}

export function getCachedGet(key, fetcher, ttlMs = DEFAULT_TTL_MS) {
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && now - hit.ts < ttlMs) {
    return Promise.resolve(hit.value);
  }
  if (inflight.has(key)) {
    return inflight.get(key);
  }
  const promise = Promise.resolve(fetcher())
    .then((value) => {
      cache.set(key, { value, ts: Date.now() });
      inflight.delete(key);
      return value;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });
  inflight.set(key, promise);
  return promise;
}

export function invalidateWorkoutCachePrefix(prefix) {
  for (const key of [...cache.keys(), ...inflight.keys()]) {
    if (key.startsWith(prefix)) {
      cache.delete(key);
      inflight.delete(key);
    }
  }
}

export { cacheKey };
